import React from 'react';
import { NavLink } from 'react-router-dom';

const CourseNav = () => (
  <nav className='subnav'>
    <span>Courses:</span>
    <ul>
      <li><NavLink activeClassName='is-active' to='/courses'>Course Library</NavLink></li>
      <li><NavLink activeClassName='is-active' to='/course-info/how-it-works'>How It Works</NavLink></li>
      <li><a href='http://support.bslcourses.co.uk/customer/en/portal/topics/224191-frequently-asked-questions/articles' target='_blank' rel='noopener noreferrer'>FAQs</a></li>
      <li className='subnav__picker'><NavLink activeClassName='is-active' to='/course-info/picker'>Course Picker</NavLink></li>
    </ul>
  </nav>
);

export default CourseNav;



// WEBPACK FOOTER //
// ./src/components/CourseNav/index.js